import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "features/auth";
import { LoadingSpinner, SiteContainer } from "atoms";
import { Head } from "features/misc";
import { Profile } from "./Profile";

function ProfilePage() {
  const [refreshed, setRefreshed] = React.useState<boolean>(false);
  const { refreshAuth, user, isLoading } = useAuth();
  const location = useLocation();

  React.useEffect(() => {
    if (user && !refreshed) {
      setRefreshed(true);
      refreshAuth();
    }
  }, [user, refreshed, refreshAuth]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return (
    <SiteContainer>
      <Head
        title="My Profile"
        type="profile"
        username={user.name}
        image={user.avatar?.url600}
      />

      <Profile user={user} />
    </SiteContainer>
  );
}
export { ProfilePage };
